"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddGlyph = void 0;

var _react = _interopRequireDefault(require("react"));

var _svgUtils = require("./svgUtils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AddGlyph = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  style: _svgUtils.textSvgStyle,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M 50 20 L 50 80 M 20 50 L 80 50",
    stroke: "currentcolor",
    strokeWidth: "15",
    strokeLinecap: "round"
  })
});

exports.AddGlyph = AddGlyph;